module.exports = __webpack_public_path__ + "img/st.10a52a06.svg";